import React from 'react';

function AppFooter() {
    return(
    <footer className="">
    </footer>
    );
}

export default AppFooter;